import { render, staticRenderFns } from "./TemplateHistory.vue?vue&type=template&id=3fdf6dce&scoped=true&"
import script from "./TemplateHistory.vue?vue&type=script&lang=js&"
export * from "./TemplateHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdf6dce",
  null
  
)

export default component.exports